import React, { useEffect, useState } from "react";
import Sidebarmenu from "../../SideMenu/Sidemenu";
import TopHeader from "../../TopHeader/TopHeader";
import Offcanvas from "react-bootstrap/Offcanvas";
import loder from "../../../../img/loder3.gif";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  PDFViewer,
  Image,
  Font,
} from "@react-pdf/renderer";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { InvoiceData } from "../../../../Helper/Redux/API";
import { Link } from "react-router-dom";

export default function INVOICE() {
  const dispatch = useDispatch();
  const [addmenuopen, setAddMenuOpen] = useState(false);

  const [getinvoice, setGetInvoice] = useState("");

  const getinvoiceData = () => {
    setIsLoading(true);

    dispatch(InvoiceData())
      .then((res) => {
        if (res?.payload?.status === true) {
          setGetInvoice(res?.payload?.data);
          // console.log(res?.payload?.data);
        } else {
          // toast.error(res?.payload?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching test data:", error);
        // Handle error if needed
      })
      .finally(() => {
        setIsLoading(false); // Set loading to false after data fetching completes
      });
  };

  useEffect(() => {
    getinvoiceData();
  }, []);

  const handleClose = () => {
    setAddMenuOpen(false);
  };

  const handleopan = () => {
    setAddMenuOpen(true);
  };

  const user_Role = localStorage.getItem("UserName");
  const [isLoading, setIsLoading] = useState(true);
  return (
    <>
      <div
        className="side_div_menu"
        style={{ display: "flex", height: "100%" }}
      >
        <Sidebarmenu />
        <section className="Home_page allsection">
          <TopHeader heding_text="INVOICE" />
          <div className="container-fluid">
            {/* <PDFViewer width="100%" height="800">
              <Quixote />
            </PDFViewer> */}

            <div className="table-responsive mt-4">
              <table className="table invoice_tabel">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Patients Name</th>
                    <th scope="col">Date&Time</th>
                    <th scope="col">Center</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {" "}
                  {isLoading ? (
                    // Render a loader while data is being fetched
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        <img src={loder} className="img-fluid" alt="loder" />
                      </td>
                    </tr>
                  ) : (
                    // Array.isArray(getinvoice) &&
                    // getinvoice.map((item) => (

                    Array.isArray(getinvoice) &&
                    getinvoice
                      .slice() // Create a copy of the array to avoid mutating the original
                      .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort dates in ascending order
                      .map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.patient_name}</td>
                          <td>
                            {item.date}&nbsp;&nbsp;{item.time}
                          </td>
                          <td>{item.branch_name}</td>
                          <td>
                            <Link
                              to={item.pdf}
                              className="link_btn"
                              target="_blank"
                            >
                              view
                            </Link>
                          </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
